import { render, staticRenderFns } from "./DocumentActionbarPathView.vue?vue&type=template&id=063aadd5"
import script from "./DocumentActionbarPathView.vue?vue&type=script&lang=js"
export * from "./DocumentActionbarPathView.vue?vue&type=script&lang=js"
import style0 from "./DocumentActionbarPathView.vue?vue&type=style&index=0&id=063aadd5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports